export default "__VITE_ASSET__EMolebp3__"